import {Helmet} from 'react-helmet-async';
// @mui
import {
    Card,
    Stack,
    Container,
    Typography,
    TableContainer,
    CardContent,
    Button,
    CircularProgress,
    Box,
    InputLabel,
    FormControlLabel,
    Radio,
    RadioGroup,
    Divider, Checkbox, ButtonGroup, Table, TableHead, TableRow, TableCell, TableBody, CardHeader,
} from '@mui/material';

import {useNavigate, useParams} from 'react-router-dom';

// components
import Scrollbar from '../components/scrollbar';
// sections
import {StepByStepTable} from "../sections/@dashboard/attestations";
import {GeneralLayout} from "../layouts/GeneralLayout";
import Label from "../components/label";
import TextField from "@mui/material/TextField";
import {useEffect, useState} from "react";
import {useGetNextAttestationNumberQuery, usePostCreateAttestationMutation} from "../store/attestation/attestationApi";
import PageTitle from "../components/PageTitle";
import Paper from "@mui/material/Paper";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import {CheckBox, RemoveRedEye, Web} from "@mui/icons-material";
import PrintIcon from "@mui/icons-material/Print";
import {
    useLazyAttestationDebtorStudentsWebReportQuery,
    useDebtorStudentsWebReportMutation
} from "../store/reports/reportsApi";
import copyObject from "../utils/copyObject";
import {useGetSemestersQuery} from "../store/system/systemApi";

export default function AttestationDebtorStudentsReportPage() {
    const {id} = useParams();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [webDataRequest, setWebDataRequest] = useState({
        byDate: new Date(),
        presentationType: 0,
        educationalForm: 0,
        includeNotClosedStatements: false,
        semesterId: 0
    });
    const [copyOfData, setCopyOfData] = useState(null);
    const [dataRequest] = useLazyAttestationDebtorStudentsWebReportQuery();
    const {data: semestersData} = useGetSemestersQuery();
    const [presentationType, setPresentationType] = useState(0);
    const [copyOfSemestersData, setCopyOfSemestersData] = useState(null);
    const [selectedSemester, setSelectedSemester] = useState(parseInt(localStorage.getItem('selectedSemesterId').toString(),10));
    let reportType = 'by-date';
    let byDate = null;
    let daysAfterSession = null;
    const verticalTextStyle = {textOrientation: 'sideways', writingMode: 'vertical-lr', transform: 'rotate(180deg)', fontSize: 12};

    useEffect(() => {
        if (semestersData) {
            const newSemestersData = copyObject(semestersData.data);
            setCopyOfSemestersData(newSemestersData);
            setSelectedSemester(parseInt(localStorage.getItem('selectedSemesterId').toString(),10));
        }
    }, [semestersData]);

    function formatDate(dateObj) {
        return `${dateObj.getFullYear()}-${withZero(dateObj.getMonth() + 1)}-${withZero(dateObj.getDate())}`;
    }

    function toDateString(date) {
        if (date === null || date === undefined)
            return '';

        return new Date(date).toLocaleDateString("ru-RU");
    }

    function withZero(num) {
        return num < 10 ? `0${num}` : num;
    }

    function onReportTypeChanged(value) {
        reportType = value;

        webDataRequest.filterType = reportType === 'by-date' ? 1 : 2;
    }

    async function loadData() {
        setIsLoading(true);
        webDataRequest.semesterId = selectedSemester;
        await dataRequest({data: webDataRequest}).unwrap().then((fulfilled) => {
            if (fulfilled?.success) {
                setCopyOfData(copyObject(fulfilled.faculties).sort((l,r) => l.facultyName > r.facultyName ? 1 : -1));
            } else {
                fulfilled.errors.map((item) => {
                    alert(item);
                    return 1;
                });
            }

            setIsLoading(false);
        }).catch(() => {
            setIsLoading(false);
            alert('Ошибка');
        });
    }

    function daysAfterSessionChanged(value) {
        daysAfterSession = parseInt(value, 10);
        onReportTypeChanged('days-after-session');
        webDataRequest.daysAfterSession = daysAfterSession;
    }

    function byDateChanged(value) {
        byDate = value;
        webDataRequest.byDate = value;
    }

    function getCurrentDate() {
        const date = new Date();
        return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
    }

    function getDebtorsPercentage(group) {
        return (numberOfDebtorStudentsByGroup(group) * 100 / group.numberOfStudentsInGroup).toFixed(1)
    }
    
    function debtorStudentsByGroup(group) {
        return group.debtorStudents.filter((item) => item.disciplines.find(d => d.gradeId === 2 || d.gradeId >= 6));
    }
    
    function numberOfDebtorStudentsByGroup(group) {
        const result = debtorStudentsByGroup(group).length;
        // if (result === 0) {
        //     console.warn(`no debtors for group`, group)
        // }
        
        return result;
    }

    function getAveragePercentage(groups) {
        let sumOfDebtors = 0;
        groups.forEach((item) => {
            sumOfDebtors += numberOfDebtorStudentsByGroup(item);
        });

        let totalNumberOfStudents = 0;
        groups.forEach((item) => {
            totalNumberOfStudents += item.numberOfStudentsInGroup;
        });

        if (totalNumberOfStudents === 0) {
            console.log(`no students`)
        }

        return (sumOfDebtors * 100 / totalNumberOfStudents).toFixed(1)
    }

    function sum(arr) {
        let temp = 0;
        arr.forEach((item) => {
            temp += item
        });

        return temp;
    }

    function numberOfDebtorsOfFaculty(faculty) {
        let totalNumberOfDebtors = 0;
        faculty.courses.forEach((course) => {
            totalNumberOfDebtors += sum(course.groups.map((group) => numberOfDebtorStudentsByGroup(group)))
        });
        
        if (totalNumberOfDebtors === 0) {
            console.warn(`no debtors by faculty`, faculty);
        }

        return totalNumberOfDebtors;
    }

    function numberOfDebtorsOfFacultyWithMinNumberOfBadGrades(faculty, numberOfBadGrades) {
        let totalNumberOfDebtors = 0;
        const students = [];
        faculty.courses.forEach((course) => {
            course.groups.forEach((group) => {
                const debtorStudents = debtorStudentsByGroup(group).filter((student) => student.disciplines.length >= numberOfBadGrades);
                totalNumberOfDebtors += debtorStudents.length;
                debtorStudents.forEach((student) => {
                    if (students.find((item) => item === student.studentId) === undefined) {
                        students.push(student.studentId);
                    }
                });
            });
            
            // totalNumberOfDebtors += sum(sumOfStudents)
        });
        
        if (students.length === 0) {
            console.warn(`no debtors by faculty with min number of bad grades (faculty, numberOfBadGrades)`, faculty, numberOfBadGrades);
        }
        
        return students.length; // totalNumberOfDebtors;
    }

    function numberOfDebtorsOfAllFaculties() {
        let totalNumberOfDebtors = 0;
        copyOfData?.forEach((faculty) => {
            faculty.courses.forEach((course) => {
                totalNumberOfDebtors += sum(course.groups.map((group) => debtorStudentsByGroup(group).length))
            });
        });
        
        if (totalNumberOfDebtors === 0) {
            console.warn(`no debtors by all faculties`);
        }

        return totalNumberOfDebtors;
    }

    function percentageOfDebtorsOfFaculty(faculty) {
        const groups = [];
        faculty.courses.forEach((course) => {
            course.groups.forEach((group) => {
                groups.push(group);
            })
        });

        return getAveragePercentage(groups);
    }

    function percentageOfDebtorsOfAllFaculties() {
        const groups = [];
        copyOfData?.forEach((faculty) => {
            faculty.courses.forEach((course) => {
                course.groups.forEach((group) => {
                    groups.push(group);
                })
            });
        });

        return getAveragePercentage(groups);
    }

    function numberOfDebtorsOfFacultyWithFilters(faculty, groupType, courseNumber) {
        let numberOfDebtors = 0;
        faculty.courses.filter((course) => course.courseName.startsWith(courseNumber.toString()))
            .forEach((course) => {
                course.groups.filter((group) => group.groupType.toLowerCase() === groupType.toLowerCase())
                    .forEach((group) => {
                        numberOfDebtors += numberOfDebtorStudentsByGroup(group);
                    });
            });
        
        if (numberOfDebtors === 0) {
            console.warn(`no debtors by faculty with filters (faculty, groupType, courseNumber)`, faculty, groupType, courseNumber);
        }

        return numberOfDebtors;
    }

    function totalNumberOfDebtorsOfCourse(course) {
        let temp = 0;
        course.groups.forEach((item) => {
            temp += numberOfDebtorStudentsByGroup(item);
        });
        
        if (temp === 0) {
            console.warn(`no debtors by course`, course);
        }

        return temp;
    }
    
    function getNumberOfAttestationsByCourse(course) {
        const temp = [];
        course.groups.forEach((item) => {
            if (temp.find((g) => g.groupName === item.groupName 
                && g.attestationValidFrom === item.attestationValidFrom 
                && g.attestationValidTo === item.attestationValidTo) === undefined) {
                temp.push({
                    groupName: item.groupName,
                    attestationValidFrom: item.attestationValidFrom,
                    attestationValidTo: item.attestationValidTo
                });
            }
        });
        
        if (temp.length === 0) {
            console.warn(`no attestations by course`, course);
        }

        return temp.length;
    }
    
    function unfilledDisciplinesByGroup(group) {
        const temp = [];
        
        debtorStudentsByGroup(group)?.forEach((student) => {
            const disciplines = student.disciplines.filter((discipline) => discipline.gradeId === 1);
            disciplines.forEach((discipline) => {
                if (temp.find((d) => d.disciplineName === discipline.disciplineName) === undefined) {
                    temp.push({
                        disciplineName: discipline.disciplineName
                    });
                }
            });
        });
        
        if (temp.length === 0) {
            console.warn(`no unfilled disciplines by group`, group);
        }
        
        return temp.length;
    }
    
    function unfilledDisciplinesByCourse(course) {
        let sum = 0;
        course.groups.forEach((group) => {
            sum += unfilledDisciplinesByGroup(group);
        });
        
        if (sum === 0) {
            console.warn(`no unfilled disciplines by course`, course);
        }
        
        return sum;
    }
    
    function unfilledDisciplinesByFaculty(faculty) {
        let sum = 0;
        faculty.courses.forEach((course) => {
            sum += unfilledDisciplinesByCourse(course);
        });
        
        if (sum === 0) {
            console.warn(`no unfilled disciplines by faculty`, faculty);
        }
        
        return sum;
    }
    
    function getAttestationRangesOfCourse(course) {
        const ranges = [];
        course.groups.forEach((group) => {
            if (ranges.find((item) => item.attestationValidFrom === group.attestationValidFrom && item.attestationValidTo === group.attestationValidTo) === undefined) {
                ranges.push({
                    attestationValidFrom: group.attestationValidFrom,
                    attestationValidTo: group.attestationValidTo
                });
            }
        });
        
        return ranges.map((item) => {
            return `${toDateString(course.groups[0]?.attestationValidFrom)} - ${toDateString(course.groups[0]?.attestationValidTo)}`
        });
    }
    
    function numberOfStudentsByGradeDisciplineAndEmployee(group, disciplineName, gradeId, employeeFullName) {
        const result = [];
        group.debtorStudents.forEach((student) => {
            student.disciplines.forEach((discipline) => {
                if (discipline.disciplineName === disciplineName && discipline.gradeId === gradeId) {
                    if (discipline.employeeNames.find((item) => item === employeeFullName) !== undefined) {
                        if (result.find((item) => item === student.studentId) === undefined) {
                            result.push(student.studentId);
                        }
                    }
                }
            })
        });
        
        if (result.length === 0) {
            console.warn(`no students by grade, discipline and employee`, group, disciplineName, gradeId, employeeFullName);
        }
        
        return result.length;
    }
    
    function getDebtorEmployeesOfGroup(group) {
        const result = [];
        group?.debtorStudents.filter((student) => student.disciplines.find((discipline) => discipline.gradeId === 1))?.forEach((student) => {
            student.disciplines.filter((discipline) => discipline.gradeId === 1).forEach((discipline) => {
                let existingDiscipline = result.find((item) => item.disciplineName === discipline.disciplineName);
                if (existingDiscipline === undefined) {
                    existingDiscipline = {
                        disciplineName: discipline.disciplineName,
                        groupName: group.groupName,
                        numberOfStudentsInGroup: group.numberOfStudentsInGroup,
                        numberOfDebtorsInSubGroup: numberOfDebtorStudentsByGroup(group),
                        employees: []
                    };
                    
                    result.push(existingDiscipline);
                }

                discipline.employeeNames.forEach((employee) => {
                    if (existingDiscipline.employees.find((item) => item === employee) === undefined) {
                        existingDiscipline.employees.push(employee);
                    }
                });
            });
        });
        
        if (result.length === 0) {
            console.warn(`no debtor employees by group`, group);
        }
        
        return result;
    }

    return (
        <GeneralLayout>
            <PageTitle title={`Задолжники по аттестации`}/>

            <Container>
                <Stack direction="column"
                       padding="120px 0px 0px 100px"
                       spacing={2}>
                    <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
                        <Typography variant="h4" gutterBottom>
                            Задолжники по аттестации
                        </Typography>
                    </Stack>

                    <Card>
                        <CardContent>
                            <Stack spacing={1}>
                                <RadioGroup defaultValue="by-date"
                                            onChange={(event) => onReportTypeChanged(event.target.value)}>
                                    <Stack spacing={1}>
                                        <Stack spacing={3} direction={'row'} alignItems={'center'}>
                                            <Paper elevation={0}>
                                                <FormControlLabel control={<Radio/>}
                                                                  value={'by-date'}
                                                                  label={'Сбор статистики на указанную дату'}/>

                                                <TextField type={'date'}
                                                           defaultValue={getCurrentDate()}
                                                           onChange={(event) => {
                                                               byDateChanged(event.target.value)
                                                           }}
                                                           placeholder={'Дата экзаменов'}
                                                           size={'small'}/>
                                            </Paper>

                                            <Stack spacing={3} direction={'row'} alignItems={'center'}>
                                                <Typography><strong>Семестр</strong></Typography>
                                                <Select fullWidth
                                                        value={selectedSemester}
                                                        onChange={(event) => {
                                                            setSelectedSemester(event.target.value)
                                                        }}
                                                        size={'small'}>
                                                    {copyOfSemestersData?.map((item) => {
                                                        return <MenuItem key={item.key}
                                                                         value={item.key}>{item.value}</MenuItem>
                                                    })}
                                                </Select>
                                            </Stack>
                                        </Stack>

                                        <Divider/>

                                        <Stack direction={'row'} spacing={3}>
                                            <Stack>
                                                <Typography><strong>Тип представления</strong></Typography>
                                                <Select size={'small'} defaultValue={0} onChange={(event) => {
                                                    webDataRequest.presentationType = event.target.value;
                                                    setPresentationType(event.target.value)
                                                }}>
                                                    <MenuItem value={0}>Количество студентов</MenuItem>
                                                    <MenuItem value={1}>ФИО студентов</MenuItem>
                                                    <MenuItem value={2}>ФИО преподавателей</MenuItem>
                                                </Select>
                                            </Stack>

                                            <Stack>
                                                <Typography><strong>Форма обучения</strong></Typography>
                                                <Select size={'small'} defaultValue={0} onChange={(event) => {
                                                    webDataRequest.educationalForm = event.target.value
                                                }}>
                                                    <MenuItem value={0}>Все</MenuItem>
                                                    <MenuItem value={1}>Заочная</MenuItem>
                                                    <MenuItem value={2}>Очная</MenuItem>
                                                    <MenuItem value={3}>Очно-Заочная</MenuItem>
                                                </Select>
                                            </Stack>

                                            <FormControlLabel control={<Checkbox/>}
                                                              onChange={(event, checked) => {
                                                                  webDataRequest.includeNotClosedStatements = checked
                                                              }}
                                                              label={`Учитывать открытые аттестации`}/>
                                        </Stack>

                                        <Divider/>

                                        <ButtonGroup orientation={'vertical'} disabled={isLoading}>
                                            {/* <Button variant={'outlined'} */}
                                            {/*        startIcon={<PrintIcon/>} */}
                                            {/*        size={'small'}>Печать</Button> */}
                                            <Button variant={'contained'}
                                                    onClick={() => {
                                                        loadData()
                                                    }}
                                                    disabled={!selectedSemester}
                                                    startIcon={isLoading ? <CircularProgress size={15}/> :
                                                        <RemoveRedEye/>}
                                                    size={'small'}>Просмотр</Button>
                                        </ButtonGroup>

                                        {isLoading
                                            ? <><Divider/>

                                                <Typography align={'center'} color={'gray'}>Сбор статистики может занять
                                                    некоторое время</Typography></>
                                            : <></>}
                                    </Stack>
                                </RadioGroup>
                            </Stack>
                        </CardContent>
                    </Card>

                    <Divider/>

                    {copyOfData !== null && copyOfData !== undefined && copyOfData.length > 0
                        ? presentationType === 0
                            ? <><Typography variant={'h5'}>Общая статистика по факультетам</Typography>
                                <Card>
                                    <TableContainer>
                                        <Table size={'small'} stickyHeader>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell align={'center'} rowSpan={3}>Факультет</TableCell>
                                                    <TableCell align={'center'} rowSpan={3} sx={verticalTextStyle}>Количество групп</TableCell>
                                                    <TableCell align={'center'} rowSpan={3} sx={verticalTextStyle}>Количество запущенных аттестаций (по группам)</TableCell>
                                                    <TableCell align={'center'} rowSpan={3} sx={verticalTextStyle}>Количество завершенных аттестаций (по группам)</TableCell>
                                                    <TableCell align={'center'} rowSpan={3} sx={verticalTextStyle}>Количество неаттестованных</TableCell>
                                                    <TableCell align={'center'} rowSpan={3} sx={verticalTextStyle}>Количество неаттестованных (2 и более не аттестаций)</TableCell>
                                                    <TableCell align={'center'} rowSpan={3} sx={verticalTextStyle}>Не аттестованно, %</TableCell>
                                                    <TableCell align={'center'} colSpan={20}>Количество неаттестованных по курсам</TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell style={{'borderLeft': '1px solid gray'}} colSpan={4}
                                                               align={'center'}>1</TableCell>
                                                    <TableCell style={{'borderLeft': '1px solid gray'}} colSpan={4}
                                                               align={'center'}>2</TableCell>
                                                    <TableCell style={{'borderLeft': '1px solid gray'}} colSpan={3}
                                                               align={'center'}>3</TableCell>
                                                    <TableCell style={{'borderLeft': '1px solid gray'}} colSpan={3}
                                                               align={'center'}>4</TableCell>
                                                    <TableCell style={{'borderLeft': '1px solid gray'}} colSpan={3}
                                                               align={'center'}>5</TableCell>
                                                    <TableCell style={{'borderLeft': '1px solid gray'}} colSpan={3}
                                                               align={'center'}>6</TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell style={{'borderLeft': '1px solid gray'}}>С</TableCell>
                                                    <TableCell>Б</TableCell>
                                                    <TableCell>М</TableCell>
                                                    <TableCell>П</TableCell>

                                                    <TableCell style={{'borderLeft': '1px solid gray'}}>С</TableCell>
                                                    <TableCell>Б</TableCell>
                                                    <TableCell>М</TableCell>
                                                    <TableCell>П</TableCell>

                                                    <TableCell style={{'borderLeft': '1px solid gray'}}>С</TableCell>
                                                    <TableCell>Б</TableCell>
                                                    <TableCell>П</TableCell>

                                                    <TableCell style={{'borderLeft': '1px solid gray'}}>С</TableCell>
                                                    <TableCell>Б</TableCell>
                                                    <TableCell>П</TableCell>

                                                    <TableCell style={{'borderLeft': '1px solid gray'}}>С</TableCell>
                                                    <TableCell>Б</TableCell>
                                                    <TableCell>П</TableCell>

                                                    <TableCell style={{'borderLeft': '1px solid gray'}}>С</TableCell>
                                                    <TableCell>Б</TableCell>
                                                    <TableCell>П</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {copyOfData?.map((faculty) => {
                                                    return <TableRow>
                                                        <TableCell>{faculty.facultyName}</TableCell>
                                                        <TableCell align={'center'}>{faculty.totalNumberOfGroups}</TableCell>
                                                        <TableCell align={'center'}>{faculty.numberOfStartedAttestations}</TableCell>
                                                        <TableCell align={'center'}>{faculty.numberOfFinishedAttestations}</TableCell>
                                                        <TableCell align={'center'}>{numberOfDebtorsOfFaculty(faculty)}</TableCell>
                                                        <TableCell align={'center'}>{numberOfDebtorsOfFacultyWithMinNumberOfBadGrades(faculty, 2)}</TableCell>
                                                        <TableCell align={'center'}>{percentageOfDebtorsOfFaculty(faculty)}%</TableCell>

                                                        <TableCell>{numberOfDebtorsOfFacultyWithFilters(faculty, 'С', 1)}</TableCell>
                                                        <TableCell>{numberOfDebtorsOfFacultyWithFilters(faculty, 'Б', 1)}</TableCell>
                                                        <TableCell>{numberOfDebtorsOfFacultyWithFilters(faculty, 'М', 1)}</TableCell>
                                                        <TableCell>{numberOfDebtorsOfFacultyWithFilters(faculty, 'П', 1)}</TableCell>

                                                        <TableCell>{numberOfDebtorsOfFacultyWithFilters(faculty, 'С', 2)}</TableCell>
                                                        <TableCell>{numberOfDebtorsOfFacultyWithFilters(faculty, 'Б', 2)}</TableCell>
                                                        <TableCell>{numberOfDebtorsOfFacultyWithFilters(faculty, 'М', 2)}</TableCell>
                                                        <TableCell>{numberOfDebtorsOfFacultyWithFilters(faculty, 'П', 2)}</TableCell>

                                                        <TableCell>{numberOfDebtorsOfFacultyWithFilters(faculty, 'С', 3)}</TableCell>
                                                        <TableCell>{numberOfDebtorsOfFacultyWithFilters(faculty, 'Б', 3)}</TableCell>
                                                        <TableCell>{numberOfDebtorsOfFacultyWithFilters(faculty, 'П', 3)}</TableCell>

                                                        <TableCell>{numberOfDebtorsOfFacultyWithFilters(faculty, 'С', 4)}</TableCell>
                                                        <TableCell>{numberOfDebtorsOfFacultyWithFilters(faculty, 'Б', 4)}</TableCell>
                                                        <TableCell>{numberOfDebtorsOfFacultyWithFilters(faculty, 'П', 4)}</TableCell>

                                                        <TableCell>{numberOfDebtorsOfFacultyWithFilters(faculty, 'С', 5)}</TableCell>
                                                        <TableCell>{numberOfDebtorsOfFacultyWithFilters(faculty, 'Б', 5)}</TableCell>
                                                        <TableCell>{numberOfDebtorsOfFacultyWithFilters(faculty, 'П', 5)}</TableCell>

                                                        <TableCell>{numberOfDebtorsOfFacultyWithFilters(faculty, 'С', 6)}</TableCell>
                                                        <TableCell>{numberOfDebtorsOfFacultyWithFilters(faculty, 'Б', 6)}</TableCell>
                                                        <TableCell>{numberOfDebtorsOfFacultyWithFilters(faculty, 'П', 6)}</TableCell>
                                                    </TableRow>
                                                })}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Card>

                                <Stack >
                                    <Typography align={'right'}><strong>По всем
                                        факультетам*: </strong> {numberOfDebtorsOfAllFaculties()} чел.
                                        ({percentageOfDebtorsOfAllFaculties()}%)</Typography>
                                    <Typography align={'right'} fontSize={'small'}>* в расчёт берутся факультеты из
                                        списка ниже</Typography>
                                </Stack>

                                <Divider/>

                                <Typography variant={'h5'}>Подробная статистика</Typography>

                                {copyOfData?.sort((l, r) => l.facultyName > r.facultyName ? 1 : -1).map((item) => {
                                    return <Card>
                                        <CardContent>
                                            <Typography variant={'h6'}>Факультет {item.facultyName}</Typography>
                                        </CardContent>
                                        <Table size={'small'}>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell>Курс</TableCell>
                                                    <TableCell align={'center'}>Период аттестации</TableCell>
                                                    <TableCell align={'center'}>Группа</TableCell>
                                                    <TableCell align={'center'}>Кол-во неаттестованных</TableCell>
                                                    <TableCell align={'center'}>Процент неаттестованных</TableCell>
                                                    <TableCell align={'center'}>Количество незаполненных дисциплин</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {item.courses.sort((l, r) => l.courseName > r.courseName ? 1 : -1).map((course) => {
                                                    return <>
                                                        <TableRow>
                                                            <TableCell
                                                                rowSpan={getNumberOfAttestationsByCourse(course) + 1}>{`${course.courseName}`}
                                                            </TableCell>
                                                            <TableCell align={'center'}>{toDateString(course.groups[0]?.attestationValidFrom)} - {toDateString(course.groups[0]?.attestationValidTo)}</TableCell>
                                                            <TableCell align={'center'}>{course.groups[0]?.groupName} ({course.groups[0]?.numberOfStudentsInGroup})</TableCell>
                                                            <TableCell align={'center'}>{numberOfDebtorStudentsByGroup(course.groups[0])}</TableCell>
                                                            <TableCell align={'center'}>{getDebtorsPercentage(course.groups[0])}%</TableCell>
                                                            <TableCell align={'center'}>{unfilledDisciplinesByGroup(course.groups[0])}</TableCell>
                                                       </TableRow>
                                                        {course.groups.sort((l, r) => l.groupName > r.groupName ? 1 : -1).slice(1).map((group) => {
                                                            return <TableRow>
                                                                <TableCell align={'center'}>{toDateString(group.attestationValidFrom)} - {toDateString(group.attestationValidTo)}</TableCell>
                                                                <TableCell align={'center'}>{group.groupName} ({group.numberOfStudentsInGroup})</TableCell>
                                                                <TableCell align={'center'}>{numberOfDebtorStudentsByGroup(group)}</TableCell>
                                                                <TableCell align={'center'}>{getDebtorsPercentage(group)}%</TableCell>
                                                                <TableCell align={'center'}>{unfilledDisciplinesByGroup(group)}</TableCell>
                                                            </TableRow>
                                                        })}
                                                        <TableRow style={{'backgroundColor': 'lightgray'}}>
                                                            <TableCell align={'right'} colSpan={2}><strong>ВСЕГО</strong></TableCell>
                                                            <TableCell align={'center'}>
                                                                <strong>
                                                                {sum(course.groups.map((group) => {
                                                                    return numberOfDebtorStudentsByGroup(group);
                                                                }))}
                                                                </strong>
                                                            </TableCell>
                                                            <TableCell align={'center'}><strong>{getAveragePercentage(course.groups)}%</strong></TableCell>
                                                            <TableCell align={'center'}><strong>{unfilledDisciplinesByCourse(course)}</strong></TableCell>
                                                        </TableRow>
                                                    </>
                                                })}
                                                <TableRow style={{'backgroundColor': 'lightgray'}}>
                                                    <TableCell colSpan={3}><strong>Всего по факультету</strong></TableCell>
                                                    <TableCell
                                                        align={'center'}><strong>{numberOfDebtorsOfFaculty(item)}</strong></TableCell>
                                                    <TableCell
                                                        align={'center'}><strong>{percentageOfDebtorsOfFaculty(item)}%</strong></TableCell>
                                                    <TableCell
                                                        align={'center'}><strong>{unfilledDisciplinesByFaculty(item)}</strong></TableCell>
                                                </TableRow>
                                            </TableBody>
                                        </Table>
                                    </Card>
                                })}
                            </>
                            : presentationType === 1 
                                ? 
                                <>
                                {copyOfData?.sort((l, r) => l.facultyName > r.facultyName ? 1 : -1)
                                    .filter((item) => item.courses.find(c => c.groups.find(g => numberOfDebtorStudentsByGroup(g) > 0)))
                                    .map((item) => {
                                    return <Card>
                                        <CardContent>
                                            <Typography variant={'h6'}>Факультет {item.facultyName}</Typography>
                                        </CardContent>
                                        <Table size={'small'} >
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell>Курс</TableCell>
                                                    <TableCell align={'center'}>Период аттестации</TableCell>
                                                    <TableCell align={'center'}>Группа</TableCell>
                                                    <TableCell align={'center'}>Студент</TableCell>
                                                    <TableCell align={'center'}>Наименование дисциплины с неаттестацией</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {item.courses.filter((course) => course.groups.find(g => numberOfDebtorStudentsByGroup(g) > 0)).sort((l, r) => l.courseName > r.courseName ? 1 : -1).map((course) => {
                                                    return <>
                                                        <TableRow>
                                                            <TableCell
                                                                rowSpan={totalNumberOfDebtorsOfCourse(course)}>{course.courseName}</TableCell>
                                                            <TableCell align={'center'} rowSpan={numberOfDebtorStudentsByGroup(course.groups.sort((l, r) => l.groupName > r.groupName ? 1 : -1)[0])}>
                                                                ({toDateString(course.groups.sort((l, r) => l.groupName > r.groupName ? 1 : -1)[0]?.attestationValidFrom)} - {toDateString(course.groups.sort((l, r) => l.groupName > r.groupName ? 1 : -1)[0]?.attestationValidTo)})
                                                            </TableCell>
                                                            <TableCell align={'center'}
                                                                       rowSpan={numberOfDebtorStudentsByGroup(course.groups.sort((l, r) => l.groupName > r.groupName ? 1 : -1)[0])}>
                                                                {course.groups.sort((l, r) => l.groupName > r.groupName ? 1 : -1)[0].groupName}
                                                            </TableCell>
                                                            <TableCell
                                                                align={'center'}><a rel="noopener noreferrer" target="_blank" style={{ color: '#0066cc' }} href={`https://att.kubsau.ru/student-card/${debtorStudentsByGroup(course.groups.sort((l, r) => l.groupName > r.groupName ? 1 : -1)[0])?.sort((l, r) => l.fullName > r.fullName ? 1 : -1)[0]?.studentId}`}>{debtorStudentsByGroup(course.groups.sort((l, r) => l.groupName > r.groupName ? 1 : -1)[0])?.sort((l, r) => l.fullName > r.fullName ? 1 : -1)[0]?.fullName}</a></TableCell>
                                                            <TableCell
                                                                align={'center'}>{debtorStudentsByGroup(course.groups?.sort((l, r) => l.groupName > r.groupName ? 1 : -1)[0])?.sort((l, r) => l.fullName > r.fullName ? 1 : -1)[0]?.disciplines?.sort((l,r) => l.disciplineName > r.disciplineName ? 1 : -1).map((d, idx) => (
                                                                <span>
                                                                        {d.disciplineName} ({d.gradeName}) [{d.employeeNames.join(', ')}]
                                                                    {idx < debtorStudentsByGroup(course.groups.sort((l, r) => l.groupName > r.groupName ? 1 : -1)[0]).sort((l, r) => l.fullName > r.fullName ? 1 : -1)[0]?.disciplines?.length - 1 && ', '}
                                                                </span>
                                                            ))}</TableCell>
                                                        </TableRow>
                                                        {debtorStudentsByGroup(course.groups.sort((l, r) => l.groupName > r.groupName ? 1 : -1)[0]).sort((l, r) => l.fullName > r.fullName ? 1 : -1).slice(1).map((student) => {
                                                            return <TableRow> 
                                                                <TableCell
                                                                    align={'center'}> <a rel="noopener noreferrer" target="_blank" style={{ color: '#0066cc' }} href={`https://att.kubsau.ru/student-card/${student.studentId}`}>{student.fullName}</a> </TableCell>
                                                                <TableCell
                                                                    align={'center'}>{student.disciplines.sort((l,r) => l.disciplineName > r.disciplineName ? 1 : -1).map((d, idx) => (
                                                                    <span>
                                                                        {d.disciplineName} ({d.gradeName}) [{d.employeeNames.join(', ')}]
                                                                        {idx < student.disciplines.length - 1 && ', '}
                                                                    </span>
                                                                ))}
                                                                </TableCell>
                                                            </TableRow>
                                                        })}
                                                        {course.groups.sort((l, r) => l.groupName > r.groupName ? 1 : -1).slice(1).map((group) => {
                                                            return <>
                                                                <TableRow>
                                                                    <TableCell
                                                                        rowSpan={numberOfDebtorStudentsByGroup(group)}>
                                                                        ({toDateString(group.attestationValidFrom)} - {toDateString(group.attestationValidTo)})
                                                                    </TableCell>
                                                                    <TableCell align={'center'}
                                                                               rowSpan={numberOfDebtorStudentsByGroup(group)}>{group.groupName}</TableCell>
                                                                    <TableCell align={'center'}>
                                                                        <a rel="noopener noreferrer" 
                                                                           target="_blank" 
                                                                           style={{ color: '#0066cc' }}
                                                                           href={`https://att.kubsau.ru/student-card/${debtorStudentsByGroup(group)?.sort((l, r) => l.fullName > r.fullName ? 1 : -1)[0]?.studentId}`}>
                                                                            {debtorStudentsByGroup(group).sort((l, r) => l.fullName > r.fullName ? 1 : -1)[0]?.fullName}
                                                                        </a>
                                                                    </TableCell>
                                                                    <TableCell
                                                                        align={'center'}>
                                                                        {debtorStudentsByGroup(group).sort((l, r) => l.fullName > r.fullName ? 1 : -1)[0]?.disciplines.map((d, idx) => (
                                                                        <span>
                                                                            {d.disciplineName} 
                                                                            {idx < debtorStudentsByGroup(group).sort((l, r) => l.fullName > r.fullName ? 1 : -1)[0]?.disciplines.length - 1 && ', '}
                                                                        </span>
                                                                        ))}
                                                                    </TableCell>
                                                                </TableRow>
                                                                
                                                                {debtorStudentsByGroup(group).sort((l, r) => l.fullName > r.fullName ? 1 : -1).slice(1).map((student) => {
                                                                    return <TableRow>
                                                                        <TableCell
                                                                            align={'center'}> <a rel="noopener noreferrer" target="_blank" style={{ color: '#0066cc' }} href={`https://att.kubsau.ru/student-card/${student.studentId}`}>{student.fullName}</a>  </TableCell>
                                                                        <TableCell align={'center'}>{student.disciplines.map((d, idx) => (
                                                                            <span>
                                                                                {d.disciplineName}
                                                                                {idx < student.disciplines.length - 1 && ', '}
                                                                            </span>
                                                                        ))}</TableCell>
                                                                    </TableRow>
                                                                })}
                                                            </>
                                                        })}
                                                    </>
                                                })}
                                            </TableBody>
                                        </Table>
                                    </Card>
                                })}
                            </>
                        : presentationType === 2 
                            ? <>
                                <Card>
                                    <Table size={'small'}>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell rowSpan={2}>ФИО экзаменатора, дисциплина</TableCell>
                                                <TableCell align={'center'} rowSpan={2}>Группа, кол-во студентов</TableCell>
                                                <TableCell align={'center'} rowSpan={2}>Не аттестовано, %</TableCell>
                                                <TableCell align={'center'} colSpan={3}>В т.ч.</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell align={'center'}>н/д</TableCell>
                                                <TableCell align={'center'}>неуд.</TableCell>
                                                <TableCell align={'center'}>"-"</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {copyOfData?.map((faculty) => {
                                                return <>
                                                    <TableRow>
                                                        <TableCell align={'center'} colSpan={6}><strong>{faculty.facultyName}</strong></TableCell>
                                                    </TableRow>
                                                    {faculty.courses.sort((l, r) => l.courseName > r.courseName ? 1 : -1).map((course) => {
                                                        return <>
                                                            <TableRow>
                                                                <TableCell align={'center'} colSpan={6}><strong>{course.courseName} ({getAttestationRangesOfCourse(course).join(', ')})</strong></TableCell>
                                                            </TableRow>
                                                            {course.groups.sort((l, r) => l.groupName > r.groupName ? 1 : -1).map((group) => {
                                                                return getDebtorEmployeesOfGroup(group).map((groupDebt) => {
                                                                    const numberOfDebtStudents = (numberOfStudentsByGradeDisciplineAndEmployee(group, groupDebt.disciplineName, 6, groupDebt.employees[0]) +
                                                                        numberOfStudentsByGradeDisciplineAndEmployee(group, groupDebt.disciplineName, 2, groupDebt.employees[0]) +
                                                                        numberOfStudentsByGradeDisciplineAndEmployee(group, groupDebt.disciplineName, 1, groupDebt.employees[0]));
                                                                    return <TableRow>
                                                                        <TableCell>
                                                                            {groupDebt.employees.sort().join(', ')}
                                                                            <br />
                                                                            {groupDebt.disciplineName}
                                                                        </TableCell>
                                                                        <TableCell align={'center'}>{groupDebt.groupName} ({groupDebt.numberOfStudentsInGroup})</TableCell>
                                                                        <TableCell align={'center'}>
                                                                            {numberOfDebtStudents}<br />
                                                                            {(numberOfDebtStudents * 100 / groupDebt.numberOfStudentsInGroup).toFixed(2)}%
                                                                        </TableCell>
                                                                        <TableCell align={'center'}>{numberOfStudentsByGradeDisciplineAndEmployee(group, groupDebt.disciplineName, 6, groupDebt.employees[0])}</TableCell>
                                                                        <TableCell align={'center'}>{numberOfStudentsByGradeDisciplineAndEmployee(group, groupDebt.disciplineName, 2, groupDebt.employees[0])}</TableCell>
                                                                        <TableCell align={'center'}>{numberOfStudentsByGradeDisciplineAndEmployee(group, groupDebt.disciplineName, 1, groupDebt.employees[0])}</TableCell>
                                                                    </TableRow>
                                                                })
                                                            })}
                                                            </>
                                                    })}
                                                </>
                                            })}
                                        </TableBody>
                                    </Table>
                                </Card>
                            </>
                            : <></>
                        : <Typography fontSize={'large'} align={'center'}>{copyOfData === null || isLoading ? 'Выберите необходимые фильтры, после чего нажмите на кнопку "Просмотр"' : 'Нет данных по выбранным фильтрам'}</Typography>
                    }
                    <br/>
                </Stack>
            </Container>
        </GeneralLayout>
    )
        ;
}
